/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Reset_FiltersInputs */

const en_common_reset_filters = /** @type {(inputs: Common_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Filters`)
};

/**
* | output |
* | --- |
* | "Reset Filters" |
*
* @param {Common_Reset_FiltersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_reset_filters = /** @type {((inputs?: Common_Reset_FiltersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Reset_FiltersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_reset_filters(inputs)
});